import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { Button, FormControlLabel, MenuItem, Radio, Typography, Checkbox, Toolbar, AppBar } from 'material-ui';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import TextField from 'material-ui/TextField';
import Formsy from 'formsy-react';
import classNames from 'classnames';
import IconButton from 'material-ui/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withAlert } from 'react-alert';
import brokerAdd, { loadData } from './brokerAdd';
import axios from 'axios';
// import classNames from 'classnames';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';

const styles = theme => ({
    layoutRoot: {}
})

class BrokerAddDailog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loadTitleTypes: [],
            isSuspend: false,
            openComposeDialog: false,
            loading: true,
            isActive: false,
            isSuspends: false,
            isActives: false,
            isTableAdd: false,
            brokerObj: null,
            noOfDeals: '',
            lastDealdate: '',
            value: ''
        };
        // alert(this.props.ref_no)
        // this.loadData();
        this.loadEmployeeTitleTypes();
        this.openNewCustomerDialog = this.openNewCustomerDialog.bind(this);
        this.closeNewCustomerDialog = this.closeNewCustomerDialog.bind(this);
    }

    // load employee gender into drop-down
    loadEmployeeTitleTypes() {
        var loadTitleTypes = [];

        axios.get(window.systemServer+'/system/loadTitle')
            .then(response => {
                console.log();
                for (let i = 0; i < response.data.length; i++) {

                    loadTitleTypes.push({
                        value: response.data[i].title
                    });
                }
                this.setState({ loadTitleTypes: loadTitleTypes });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }


    loadData() {
        var resObj;
        var brokerObjArray = []
        var length;
        var lastDate;
        // axios.get('http://localhost:5006/broker/getBrokersList')
        axios.get(window.salesServer+'/broker/getBrokersList')
            .then(response => {
                if (response.data.success) {
                    this.setState({ brokerObj: response.data.brokers });
                    resObj = response.data.invoices;

                    for (var i = 0; i < this.state.brokerObj.length; i++) {

                        var allDataObj = {};
                        allDataObj.id = this.state.brokerObj[i].ID_SALES_BROKER,
                            allDataObj.broker_code = this.state.brokerObj[i].CODE,
                            allDataObj.broker_name = this.state.brokerObj[i].NAME,
                            allDataObj.broker_ref_number = this.state.brokerObj[i].REFERENCE_NUMBER,
                            allDataObj.broker_title = this.state.brokerObj[i].TITLE,
                            allDataObj.broker_nic = this.state.brokerObj[i].NIC,
                            allDataObj.address = this.state.brokerObj[i].ADDRESS,
                            allDataObj.address2 = this.state.brokerObj[i].ADDRESS_LINE_2,
                            allDataObj.state = this.state.brokerObj[i].STATE,
                            allDataObj.city = this.state.brokerObj[i].CITY,
                            allDataObj.zipcode = this.state.brokerObj[i].ZIP_CODE,
                            allDataObj.countrycode = this.state.brokerObj[i].COUNTRY_CODE,
                            allDataObj.email = this.state.brokerObj[i].EMAIL,
                            allDataObj.mobile = this.state.brokerObj[i].MOBILE,
                            allDataObj.telephone = this.state.brokerObj[i].TELEPHONE,
                            allDataObj.fax = this.state.brokerObj[i].FAX,
                            allDataObj.is_active = this.state.brokerObj[i].IS_ACTIVE,
                            allDataObj.is_suspend = this.state.brokerObj[i].isSuspended
                        if (this.state.brokerObj[i].IS_ACTIVE == 1) {
                            allDataObj.is_active_value = 'Active'
                        } else {
                            allDataObj.is_active_value = 'Inactive'
                        }
                        if (this.state.brokerObj[i].isSuspended == 1) {
                            allDataObj.is_suspend_value = 'Suspended'
                        } else {
                            allDataObj.is_suspend_value = 'info'
                        }

                        const countTypes = resObj.filter(movie => movie.ID_SALES_BROKER === this.state.brokerObj[i].ID_SALES_BROKER);
                        console.log("fdfdf " + JSON.stringify(countTypes));
                        if (countTypes.length == 0) {
                            allDataObj.last_deal_date = "";
                        } else {
                            var end_date = new Date(countTypes[0].CREATED_DATE)
                            var expected_date = end_date.getFullYear() + '-' + end_date.getMonth() + '-' + end_date.getDate();
                            allDataObj.last_deal_date = expected_date;
                        }
                        // allDataObj.last_deal_date = "",
                        allDataObj.no_of_deals = countTypes.length
                        brokerObjArray.push(allDataObj)
                    }

                    this.appendToTable(brokerObjArray)

                }


            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

        this.handleCloseEdit();
    }

    appendToTable(brokerObj) {

        console.log(brokerObj)
        var data = [];
        for (var i = 0; i < brokerObj.length; i++) {
            data.push({
                id: brokerObj[i].id,
                broker_code: brokerObj[i].broker_code,
                broker_name: brokerObj[i].broker_name,
                broker_ref_number: brokerObj[i].broker_ref_number,
                broker_title: brokerObj[i].broker_title,
                broker_nic: brokerObj[i].broker_nic,
                address: brokerObj[i].address,
                address2: brokerObj[i].address2,
                state: brokerObj[i].state,
                city: brokerObj[i].city,
                zipcode: brokerObj[i].zipcode,
                countrycode: brokerObj[i].countrycode,
                email: brokerObj[i].email,
                mobile: brokerObj[i].mobile,
                telephone: brokerObj[i].telephone,
                fax: brokerObj[i].fax,
                is_active: brokerObj[i].is_active,
                is_suspend: brokerObj[i].is_suspend,
                last_deal_date: brokerObj[i].last_deal_date,
                no_of_deals: brokerObj[i].no_of_deals,
                is_active_value: brokerObj[i].is_active_value,
                is_suspend_value: brokerObj[i].is_suspend_value
            });

        }

        this.setState({ data: data });
        this.setState({ loading: false });
    }

    openNewCustomerDialog() {
        // this.setState({ loading: true });
        // this.setState({ expanded: 'panel1' });
        // this.clearContactPersons;
        this.setState({ openComposeDialog: true });
        // this.setState({ loading: false });
    }

    handleCloseEdit = () => {
        this.setState({ edit: false });
    };

    closeNewCustomerDialog() {
        this.setState({ openComposeDialog: false });
    }
    handleCheckSuspendChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleCheckActiveChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleCheckSuspendChanges = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleCheckActiveChanges = name => event => {
        this.setState({ [name]: event.target.checked });
    };
    clearValue = () => {
        this.form.reset();
    }
    onSubmit = (model) => {

        // if ("" == this.state.emp_profile_id || null == this.state.emp_profile_id || undefined == this.state.emp_profile_id ||
        //     "" == this.state.emp_registry_id || null == this.state.emp_registry_id || undefined == this.state.emp_registry_id) {
        //     this.props.alert.error("Unable to Saved Please Check !");
        // } else {
        this.saveBroker(model);

        // }

    };
    saveBroker(model) {

        const brokerObj = {
            broker_code: model.broker_code,
            broker_ref_no: model.broker_ref_number,
            name: model.broker_name,
            title: model.broker_title,
            nic: model.broker_nic,
            address: model.address,
            address_line2: model.address2,
            state: model.state,
            city: model.city,
            zipcode: model.zipcode,
            countrycode: model.countrycode,
            email: model.email,
            mobile: model.mobile,
            telephone: model.telephone,
            fax: model.fax,
            is_active: this.state.isActive,
            is_suspend: this.state.isSuspend
        }



        // axios.post('http://localhost:5006/broker/saveBroker', brokerObj)
        axios.post(window.salesServer+'/broker/saveBroker', brokerObj)
            .then(res => {

                if (res.data.success) {
                    // alert("Success");
                    this.props.alert.success("Broker Details Update Successfully.");

                    this.setState({
                        isActives: false,
                        isSuspends: false
                    });

                    // this.loadData();
                    this.form.reset();
                    this.setState({ openComposeDialog: false });
                } else {
                    // alert(res.data.message);
                    this.props.alert.error(res.data.message);
                }
            })


    }

    render() {
        const { classes } = this.props;
        return (
            <div>
                <Toolbar className="flex w-full pt-24 px-12 ml-1920">
                    <h2 className="w-full">

                    </h2>
                    <div className="px-12">
                        <Button
                            className="w-160"
                            type="button"
                            variant="raised"
                            color="secondary"
                            onClick={(ev) => {
                                // ev.stopPropagation();
                                // this.removeContactPerson();
                                this.openNewCustomerDialog();
                                // this.check();
                            }}
                        >
                            Add New Broker
            </Button>
                    </div>
                    <div className="px-12">
                        <Button
                            variant="raised"
                            color="default"
                        >
                            Help
                </Button>
                    </div>
                </Toolbar>

                <Dialog className={classNames(classes.root, "z-10")} open={this.state.openComposeDialog} fullWidth maxWidth="md">
                    <AppBar className="flex w-full h-50 app-bar-size" position="static">
                        <Toolbar className="flex w-full">
                            <Typography className="w-full" variant="subheading" color="inherit">
                                New Broker
                    </Typography>
                            <IconButton className="" color="inherit" onClick={this.closeNewCustomerDialog} aria-label="Close">
                                <CloseIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <Formsy
                        onValidSubmit={this.onSubmit}
                        onValid={this.enableButton}
                        onInvalid={this.disableButton}
                        ref={(form) => this.form = form}
                        className="flex flex-col justify-center"
                    >

                        <div className="flex flex-wrap -mx-3 mb-6">
                            <div className="w-full p-16 mt-4 pr-24 border-solid border-1 rounded border-grey bg-grey-lightest">
                                {/* <TextFieldFormsy
                                    className="w-full md:w-1/6 pr-16 pr-24"
                                    type="text"
                                    name="broker_code"
                                    label="Broker Code"
                                    validations={{
                                        maxLength: 50
                                    }}
                                    validationErrors={{

                                        maxLength: 'This is not a valid'
                                    }}

                                /> */}
                                <TextFieldFormsy
                                    className="w-full md:w-1/6 pr-24"
                                    type="text"
                                    name="broker_ref_number"
                                    label="Broker Ref No"
                                    validations={{
                                        maxLength: 50
                                    }}
                                    validationErrors={{

                                        maxLength: 'This is not a valid'
                                    }}

                                />

                                <SelectFormsy
                                    className="w-full md:w-1/6 pr-24"
                                    name="broker_title"
                                    label="       "
                                    value="Mr"
                                >
                                    <MenuItem disabled value="none" ref="employeeData">
                                        <em>Broker Title</em>

                                    </MenuItem>
                                    {this.state.loadTitleTypes.map(function (item, i) {
                                        return <MenuItem value={item.value}>{item.value}</MenuItem>;
                                    })}

                                </SelectFormsy>

                                <TextFieldFormsy
                                    className="w-full md:w-1/2 pr-24"
                                    type="text"
                                    name="broker_name"
                                    label="Broker Name"
                                    required
                                    validations={{
                                        maxLength: 150
                                    }}
                                    validationErrors={{

                                        maxLength: 'This is not a valid'
                                    }}

                                />
                                <TextFieldFormsy
                                    className="w-full md:w-1/3 pr-24"
                                    type="text"
                                    name="broker_nic"
                                    label="NIC/SSN/Passport"
                                    validations={{
                                        maxLength: 50
                                    }}
                                    validationErrors={{

                                        maxLength: 'This is not a valid'
                                    }}

                                />
                            </div>
                            <div className="w-full p-16 mt-8 pr-24 border-solid border-1 rounded border-grey bg-grey-lightest">
                                <div >
                                    <h3 className="mt-16">Contact Details</h3>
                                </div>

                                <TextFieldFormsy
                                    className="w-full md:w-1/3 pr-24"
                                    type="text"
                                    name="address"
                                    label="Address"
                                    required
                                    validations={{
                                        maxLength: 150
                                    }}
                                    validationErrors={{

                                        maxLength: 'This is not a valid'
                                    }}
                                />
                                <TextFieldFormsy
                                    className="w-full md:w-1/3 pr-16 pr-24"
                                    type="text"
                                    name="address2"
                                    label="Address Line 2"
                                    validations={{
                                        maxLength: 150
                                    }}
                                    validationErrors={{

                                        maxLength: 'This is not a valid'
                                    }}

                                />
                                <TextFieldFormsy
                                    className="w-full md:w-1/3 pr-24"
                                    type="email"
                                    name="email"
                                    label="Email"
                                    validations="isEmail"
                                    validationError="This is not a valid email"
                                />

                                <TextFieldFormsy
                                    className="w-full md:w-1/4 pr-24"
                                    type="text"
                                    name="state"
                                    label="State"
                                    validations={{
                                        maxLength: 50
                                    }}
                                    validationErrors={{

                                        maxLength: 'This is not a valid'
                                    }}



                                />

                                <TextFieldFormsy
                                    className="w-full md:w-1/4 pr-24"
                                    type="text"
                                    name="city"
                                    label="City"
                                    validations={{
                                        maxLength: 50
                                    }}
                                    validationErrors={{

                                        maxLength: 'This is not a valid'
                                    }}

                                />

                                <TextFieldFormsy
                                    className="w-full md:w-1/4 pr-24"
                                    type="text"
                                    name="zipcode"
                                    label="Zip Code"
                                    validations={{
                                        maxLength: 50
                                    }}
                                    validationErrors={{

                                        maxLength: 'This is not a valid'
                                    }}

                                />

                                <TextFieldFormsy
                                    className="w-full md:w-1/4 pr-24"
                                    label="Country Code"
                                    name="countrycode"
                                    type="text"
                                    validations={{
                                        maxLength: 50
                                    }}
                                    validationErrors={{

                                        maxLength: 'This is not a valid'
                                    }}
                                />

                                <TextFieldFormsy
                                    className="w-full md:w-1/3 pr-24"

                                    label="Mobile"
                                    name="mobile"
                                    type="number"
                                    required
                                    validations={{
                                        maxLength: 20
                                    }}
                                    validationErrors={{

                                        maxLength: 'This is not a valid'
                                    }}
                                />

                                <TextFieldFormsy
                                    className="w-full md:w-1/3 pr-24"
                                    type="number"
                                    name="telephone"
                                    label="Telephone"
                                    validations={{
                                        maxLength: 20
                                    }}
                                    validationErrors={{

                                        maxLength: 'This is not a valid'
                                    }}

                                />
                                <TextFieldFormsy
                                    className="w-full md:w-1/3 pr-24"
                                    type="number"
                                    name="fax"
                                    label="Fax"
                                    validations={{
                                        maxLength: 20
                                    }}
                                    validationErrors={{

                                        maxLength: 'This is not a valid'
                                    }}

                                />


                                <div className="w-full md:w-1/4 pr-24">
                                    <FormControlLabel
                                        className=" "
                                        control={
                                            <Checkbox
                                                checked={this.state.isSuspend}
                                                onChange={this.handleCheckSuspendChange('isSuspend')}
                                                color="primary"
                                            />
                                        }
                                        label="Suspend"
                                    />
                                    <FormControlLabel
                                        className=" "
                                        control={
                                            <Checkbox
                                                checked={this.state.isActive}
                                                onChange={this.handleCheckActiveChange('isActive')}
                                                color="primary"
                                            />
                                        }
                                        label="Active"
                                    />
                                </div>

                            </div>

                            <div className="w-full md:w-2/3">

                            </div>

                            <div className="w-full md:w-1/4 float-right mb-16">
                                {/* onClick={this.saveEmployee.bind(this)} */}

                                <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 mr-8">
                                    Save
                    </Button>

                                <Button type="button" variant="raised" size="small" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16 mr-8" onClick={this.clearValue}>
                                    Clear
                    </Button>
                                <Button type="button" variant="raised" size="small" className="{classes.button} w-full md:w-1/4 md:h-24 mt-16" onClick={this.closeNewCustomerDialog}>
                                    Close
                    </Button>
                            </div>
                        </div>
                    </Formsy>
                </Dialog>
            </div>
        );
    }
}
export default withStyles(styles, { withTheme: true })(withAlert(BrokerAddDailog));


// WEBPACK FOOTER //
// ./src/main/content/sales/broker/brokerAddDailog.js